import PacksConfig from "./packs/PacksConfig";
import PlansConfig from "./plans/PlansConfig";
import SubscriptionConfig from "./subscription/SubscriptionConfig";

const accessPlansConfig = [PlansConfig, SubscriptionConfig, PacksConfig];

export default accessPlansConfig;
